import React from "react";
import { Line } from "react-chartjs-2";
import { formatViewerDateTime } from "../../../utils/viewerTimeZone";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const COLORS = ["#4fc3f7", "#4caf50", "#ff9800", "#f44336"];

export default function LineChartWidget({ title, data, labels, unit, color = "#4fc3f7", datasets: datasetsProp }) {
  const singleDataset = [
    {
      label: title,
      data: data || generateMockData(12),
      borderColor: color,
      backgroundColor: `${color}33`,
      borderWidth: 2,
      fill: true,
      tension: 0.4,
      pointRadius: 0,
      pointHoverRadius: 4,
    },
  ];
  const multiDatasets = Array.isArray(datasetsProp) && datasetsProp.length
    ? datasetsProp.map((ds, i) => ({
        label: ds.label || `Seri ${i + 1}`,
        data: ds.data || [],
        borderColor: COLORS[i % COLORS.length],
        backgroundColor: `${COLORS[i % COLORS.length]}33`,
        borderWidth: 2,
        fill: false,
        tension: 0.3,
        pointRadius: 0,
        pointHoverRadius: 4,
      }))
    : null;

  const chartData = {
    labels: labels || generateTimeLabels(data?.length || 12),
    datasets: multiDatasets || singleDataset,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { bottom: 6 },
    },
    plugins: {
      legend: { display: !!multiDatasets },
      tooltip: {
        backgroundColor: "var(--bg-card)",
        titleColor: "var(--text-secondary)",
        bodyColor: "#1a202c",
        borderColor: "var(--border)",
        borderWidth: 1,
        callbacks: {
          label: (ctx) => `${ctx.parsed.y} ${unit || ""}`,
        },
      },
    },
    scales: {
      x: {
        grid: { color: "var(--border)", drawBorder: false },
        ticks: { color: "var(--text-secondary)", font: { size: 10 }, maxRotation: 0 },
      },
      y: {
        grid: { color: "var(--border)", drawBorder: false },
        ticks: {
          color: "var(--text-secondary)",
          font: { size: 10 },
          callback: (val) => `${val}${unit ? ` ${unit}` : ""}`,
        },
      },
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>{title}</span>
      </div>
      <div style={styles.chartWrapper}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
}

function generateTimeLabels(count) {
  const labels = [];
  const now = new Date();
  for (let i = count - 1; i >= 0; i--) {
    const time = new Date(now - i * 5 * 60 * 1000);
    labels.push(formatViewerDateTime(time, undefined, { hour: "2-digit", minute: "2-digit" }));
  }
  return labels;
}

function generateMockData(count) {
  return Array.from({ length: count }, () => Math.random() * 50 + 25);
}

const styles = {
  container: {
    backgroundColor: "var(--bg-card)",
    borderRadius: "2px",
    padding: "8px 10px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    marginBottom: "4px",
  },
  title: {
    color: "var(--text-primary)",
    fontSize: "12px",
    fontWeight: "500",
  },
  chartWrapper: {
    flex: 1,
    minHeight: 0,
  },
};
